// extracted by mini-css-extract-plugin
export default {"rotate":"loading_rotate__2LsdI","rotation":"loading_rotation__QKGzz"};